import useAPI from '@/hooks/useAPI';
import RemitRepository from '@/repositories/RemitRepository';

const useRemits = (enabled = true) => {
  const remitRepository = RemitRepository();

  return useAPI({
    queryKey: ['getNewRemit'],
    queryFn: async () => {
      return await remitRepository.getNewRemit();
    },
    enabled
  });
};

export default useRemits;
